import { render } from "./ImageModal.vue?vue&type=template&id=f8810d8c&scoped=true&ts=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=f8810d8c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lucky-draw-app/lucky-draw-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8810d8c"]])

export default __exports__